/* Module Imports */
import alertsConfigModule from './alerts/alerts.module';
import faultsConfigModule from './faults/faults.module';
import geozonesConfigModule from './geozones/geozones.module';

/* Specific Imports */
import ConfigurationFilterService from './filter.utility';  // ConfigurationUtilityService

const configurationsModule = angular.module('app.configurations', [
    "ui.bootstrap",
    "ui.router",
    "gettext",
    alertsConfigModule,
    faultsConfigModule,
    geozonesConfigModule
])
.service("ConfigurationFilterService", ConfigurationFilterService);

export default configurationsModule.name;